export const formatDate = (dateString) => {
  if (!dateString) return "Жоқ";
  return new Date(dateString).toLocaleString("kk-KZ", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getStatusBadge = (status) => {
  const statusColors = {
    active: "bg-green-500/20 text-green-400 border-green-500/50",
    inactive: "bg-gray-500/20 text-gray-400 border-gray-500/50",
    pending: "bg-yellow-500/20 text-yellow-400 border-yellow-500/50",
    rejected: "bg-red-500/20 text-red-400 border-red-500/50",
  };
  return statusColors[status?.toLowerCase()] || statusColors.inactive;
};
